import React from "react";

function SvgAppIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      color="currentColor"
    >
      <defs>
        <clipPath id="clip-My_app_1">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g id="My_app_1" data-name="My app – 1" clipPath="url(#clip-My_app_1)">
        <g id="add" transform="translate(0 0)">
          <g id="Group_20007" data-name="Group 20007">
            <g id="Group_20006" data-name="Group 20006">
              <path
                id="Path_29229"
                data-name="Path 29229"
                d="M18.182,0H4.545A4.55,4.55,0,0,0,0,4.545V18.182a4.55,4.55,0,0,0,4.545,4.545H18.182a4.55,4.55,0,0,0,4.545-4.545V4.545A4.55,4.55,0,0,0,18.182,0Z"
                fill="currentColor"
              />
              <path
                id="Path_29230"
                data-name="Path 29230"
                d="M274.182,0H260.545A4.55,4.55,0,0,0,256,4.545V18.182a4.55,4.55,0,0,0,4.545,4.545h13.636a4.55,4.55,0,0,0,4.546-4.545V4.545A4.55,4.55,0,0,0,274.182,0Z"
                transform="translate(-228.727)"
                fill="currentColor"
              />
              <path
                id="Path_29231"
                data-name="Path 29231"
                d="M18.182,256H4.545A4.55,4.55,0,0,0,0,260.545v13.636a4.55,4.55,0,0,0,4.545,4.546H18.182a4.55,4.55,0,0,0,4.545-4.546V260.545A4.55,4.55,0,0,0,18.182,256Z"
                transform="translate(0 -228.727)"
                fill="currentColor"
              />
              <path
                id="Path_29232"
                data-name="Path 29232"
                d="M311.166,303.211h-3.409V299.8a1.136,1.136,0,0,0-1.136-1.136h-2.273a1.136,1.136,0,0,0-1.136,1.136v3.409H299.8a1.136,1.136,0,0,0-1.136,1.136v2.273a1.136,1.136,0,0,0,1.136,1.136h3.409v3.409a1.136,1.136,0,0,0,1.136,1.136h2.273a1.136,1.136,0,0,0,1.136-1.136v-3.409h3.409a1.136,1.136,0,0,0,1.136-1.136v-2.273A1.136,1.136,0,0,0,311.166,303.211Z"
                transform="translate(-266.848 -266.848)"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgAppIconNew);
